export default "__VITE_ASSET__CgExbssx__"